export const getRandomElementFromArray = <T = any>(array: Array<T>): T | undefined => {
    return array[Math.floor(Math.random() * array.length)];
};

export const sameArrayData = (
    array1: any[],
    array2: any[],
): boolean => (
    array1.length === array2.length
        && array1.every((value) => array2.indexOf(value) !== -1)
);
